module.exports = __webpack_public_path__ + "assets/img/542c4cf713db272f9b42a5c045b1b429.svg";